// extracted by mini-css-extract-plugin
export default {"cardrow":"CardRow_cardrow__Bji8N","classic":"CardRow_classic__sF+Bu","prev":"CardRow_prev__N8TKu","next":"CardRow_next__1myKK"};